import React from 'react';
import IconButton from '@/components/atoms/UI/buttons/IconButton';
import Icon, { IconColor, NameType } from '@/components/atoms/UI/Icon/Icon';

interface Props {
    iconName: NameType;
    label: string;
    iconColor?: IconColor;
    disabled?: boolean;
    onClick?: () => void;
    pressed?: boolean;
    /** Кастомный контент вместо дефолтной иконки (напр. анимированное сердце избранного). */
    children?: React.ReactNode;
}

/**
 * Универсальная круглая кнопка-действие с иконкой — обёртка над IconButton
 * с рендером иконки и a11y. Специфику навешивают фиче-обёртки поверх.
 */
const IconActionButton: React.FC<Props> = ({
    iconName,
    label,
    iconColor = 'white',
    disabled,
    onClick,
    pressed,
    children,
}) => (
    <IconButton
        type="button"
        large
        aria-label={label}
        aria-pressed={pressed}
        disabled={disabled}
        onClick={onClick}
    >
        {children ?? <Icon name={iconName} color={iconColor} small />}
    </IconButton>
);

export default IconActionButton;
